module.exports = __webpack_public_path__ + "img/sound_on.05337052.svg";